/*
 * Generated type guards for "types.ts".
 * WARNING: Do not manually change this file.
 */
import {
  CheckoutParams,
  STEP,
  CHECKOUT_STATE,
  PAYMENT_METHOD_TYPE,
  STRIPE_PAYMENT_TYPE,
  DONATION_FREQUENCY,
  LEGAL_PERSON,
  Checkout,
  ServerError,
} from './types';

export function isCheckoutParams(obj: unknown): obj is CheckoutParams {
  const typedObj = obj as CheckoutParams;
  return (
    ((typedObj !== null && typeof typedObj === 'object') || typeof typedObj === 'function') &&
    typeof typedObj['co'] === 'string'
  );
}

export function isCheckoutConfig(obj: unknown): obj is Checkout {
  const typedObj = obj as Checkout;
  return (
    ((typedObj !== null && typeof typedObj === 'object') || typeof typedObj === 'function') &&
    typeof typedObj['token'] === 'string' &&
    (typedObj['step'] === STEP.DONATION ||
      typedObj['step'] === STEP.SUPPORTER ||
      typedObj['step'] === STEP.PAYMENT ||
      typedObj['step'] === STEP.THANK_YOU) &&
    (typedObj['state'] === CHECKOUT_STATE.OPEN ||
      typedObj['state'] === CHECKOUT_STATE.COMPLETED ||
      typedObj['state'] === CHECKOUT_STATE.CLOSED) &&
    (typedObj['completed_date'] === null || typeof typedObj['completed_date'] === 'string') &&
    ((typedObj['campaign'] !== null && typeof typedObj['campaign'] === 'object') ||
      typeof typedObj['campaign'] === 'function') &&
    typeof typedObj['campaign']['id'] === 'number' &&
    typeof typedObj['campaign']['title'] === 'string' &&
    typeof typedObj['campaign']['slug'] === 'string' &&
    (typedObj['campaign']['cover_url'] === null ||
      typeof typedObj['campaign']['cover_url'] === 'string') &&
    typeof typedObj['campaign']['sitefront_url'] === 'string' &&
    (typedObj['campaign']['description'] === null ||
      typeof typedObj['campaign']['description'] === 'string') &&
    typeof typedObj['campaign']['has_one_off'] === 'boolean' &&
    typeof typedObj['campaign']['has_subscription'] === 'boolean' &&
    typeof typedObj['campaign']['allow_custom_amount'] === 'boolean' &&
    typeof typedObj['campaign']['allow_custom_subscription_amount'] === 'boolean' &&
    (typeof typedObj['campaign']['default_amount'] === 'undefined' ||
      typedObj['campaign']['default_amount'] === null ||
      typeof typedObj['campaign']['default_amount'] === 'number') &&
    (typeof typedObj['campaign']['default_subscription_amount'] === 'undefined' ||
      typedObj['campaign']['default_subscription_amount'] === null ||
      typeof typedObj['campaign']['default_subscription_amount'] === 'number') &&
    (typeof typedObj['campaign']['min_amount'] === 'undefined' ||
      typedObj['campaign']['min_amount'] === null ||
      typeof typedObj['campaign']['min_amount'] === 'number') &&
    (typeof typedObj['campaign']['max_amount'] === 'undefined' ||
      typedObj['campaign']['max_amount'] === null ||
      typeof typedObj['campaign']['max_amount'] === 'number') &&
    (typeof typedObj['campaign']['min_subscription_amount'] === 'undefined' ||
      typedObj['campaign']['min_subscription_amount'] === null ||
      typeof typedObj['campaign']['min_subscription_amount'] === 'number') &&
    (typeof typedObj['campaign']['max_subscription_amount'] === 'undefined' ||
      typedObj['campaign']['max_subscription_amount'] === null ||
      typeof typedObj['campaign']['max_subscription_amount'] === 'number') &&
    Array.isArray(typedObj['campaign']['asks']) &&
    typedObj['campaign']['asks'].every((e: any) => typeof e === 'number') &&
    Array.isArray(typedObj['campaign']['asks_subscription']) &&
    typedObj['campaign']['asks_subscription'].every((e: any) => typeof e === 'number') &&
    Array.isArray(typedObj['campaign']['shown_fields']) &&
    typedObj['campaign']['shown_fields'].every(
      (e: any) =>
        e === 'first_name' ||
        e === 'last_name' ||
        e === 'business_name' ||
        e === 'email' ||
        e === 'phone' ||
        e === 'mobile' ||
        e === 'address' ||
        e === 'city' ||
        e === 'country' ||
        e === 'postal_code' ||
        e === 'locality' ||
        e === 'ssn' ||
        e === 'vat',
    ) &&
    Array.isArray(typedObj['campaign']['required_fields']) &&
    typedObj['campaign']['required_fields'].every(
      (e: any) =>
        e === 'first_name' ||
        e === 'last_name' ||
        e === 'business_name' ||
        e === 'email' ||
        e === 'phone' ||
        e === 'mobile' ||
        e === 'address' ||
        e === 'city' ||
        e === 'country' ||
        e === 'postal_code' ||
        e === 'locality' ||
        e === 'ssn' ||
        e === 'vat',
    ) &&
    ((typedObj['organization'] !== null && typeof typedObj['organization'] === 'object') ||
      typeof typedObj['organization'] === 'function') &&
    typeof typedObj['organization']['name'] === 'string' &&
    (typedObj['organization']['logo'] === null ||
      typeof typedObj['organization']['logo'] === 'string') &&
    (typedObj['organization']['privacy_policy'] === null ||
      typeof typedObj['organization']['privacy_policy'] === 'string') &&
    typeof typedObj['organization']['is_development'] === 'boolean' &&
    (typedObj['organization']['tos'] === null ||
      typeof typedObj['organization']['tos'] === 'string') &&
    (typedObj['peer_campaign'] === null ||
      (((typedObj['peer_campaign'] !== null && typeof typedObj['peer_campaign'] === 'object') ||
        typeof typedObj['peer_campaign'] === 'function') &&
        typeof typedObj['peer_campaign']['supporter_name'] === 'string' &&
        (typedObj['peer_campaign']['supporter_image_src'] === null ||
          typeof typedObj['peer_campaign']['supporter_image_src'] === 'string') &&
        (typedObj['peer_campaign']['supporter_message'] === null ||
          typeof typedObj['peer_campaign']['supporter_message'] === 'string'))) &&
    (typedObj['cost_example'] === null ||
      (((typedObj['cost_example'] !== null && typeof typedObj['cost_example'] === 'object') ||
        typeof typedObj['cost_example'] === 'function') &&
        typeof typedObj['cost_example']['uuid'] === 'string' &&
        typeof typedObj['cost_example']['amount'] === 'number' &&
        (typedObj['cost_example']['image'] === null ||
          typeof typedObj['cost_example']['image'] === 'string') &&
        typeof typedObj['cost_example']['name'] === 'string' &&
        typeof typedObj['cost_example']['description'] === 'string' &&
        typeof typedObj['cost_example']['monitor_quantity'] === 'boolean' &&
        typeof typedObj['cost_example']['quantity'] === 'number' &&
        typeof typedObj['cost_example']['available_quantity'] === 'number')) &&
    Array.isArray(typedObj['enabled_payment_methods']) &&
    typedObj['enabled_payment_methods'].every(
      (e: any) =>
        (((e !== null && typeof e === 'object') || typeof e === 'function') &&
          typeof e['id'] === 'number' &&
          (e['label'] === null || typeof e['label'] === 'string') &&
          e['type'] === PAYMENT_METHOD_TYPE.STRIPE &&
          typeof e['has_oneoff_support'] === 'boolean' &&
          typeof e['has_subscription_support'] === 'boolean' &&
          (e['stripe_payment_type'] === STRIPE_PAYMENT_TYPE.SEPA_DIRECT_DEBIT ||
            e['stripe_payment_type'] === STRIPE_PAYMENT_TYPE.CREDIT_CARD ||
            e['stripe_payment_type'] === STRIPE_PAYMENT_TYPE.POS) &&
          typeof e['stripe_account_id'] === 'string' &&
          typeof e['stripe_pub_key'] === 'string') ||
        (((e !== null && typeof e === 'object') || typeof e === 'function') &&
          typeof e['id'] === 'number' &&
          (e['label'] === null || typeof e['label'] === 'string') &&
          e['type'] === PAYMENT_METHOD_TYPE.PAYPAL &&
          typeof e['has_oneoff_support'] === 'boolean' &&
          typeof e['has_subscription_support'] === 'boolean') ||
        (((e !== null && typeof e === 'object') || typeof e === 'function') &&
          typeof e['id'] === 'number' &&
          (e['label'] === null || typeof e['label'] === 'string') &&
          e['type'] === PAYMENT_METHOD_TYPE.MANUAL &&
          typeof e['has_oneoff_support'] === 'boolean' &&
          typeof e['has_subscription_support'] === 'boolean' &&
          (e['manual_description'] === null || typeof e['manual_description'] === 'string')) ||
        (((e !== null && typeof e === 'object') || typeof e === 'function') &&
          typeof e['id'] === 'number' &&
          (e['label'] === null || typeof e['label'] === 'string') &&
          e['type'] === PAYMENT_METHOD_TYPE.SATISPAY &&
          typeof e['has_oneoff_support'] === 'boolean' &&
          typeof e['has_subscription_support'] === 'boolean'),
    ) &&
    (typedObj['supporter_id'] === null || typeof typedObj['supporter_id'] === 'number') &&
    (typedObj['donation_id'] === null || typeof typedObj['donation_id'] === 'number') &&
    (typedObj['amount'] === null || typeof typedObj['amount'] === 'number') &&
    (typedObj['frequency'] === null ||
      typedObj['frequency'] === DONATION_FREQUENCY.ONEOFF ||
      typedObj['frequency'] === DONATION_FREQUENCY.MONTHLY) &&
    (typedObj['legal_person'] === null ||
      typedObj['legal_person'] === LEGAL_PERSON.COMPANY ||
      typedObj['legal_person'] === LEGAL_PERSON.INDIVIDUAL) &&
    (typedObj['business_name'] === null || typeof typedObj['business_name'] === 'string') &&
    (typedObj['first_name'] === null || typeof typedObj['first_name'] === 'string') &&
    (typedObj['last_name'] === null || typeof typedObj['last_name'] === 'string') &&
    (typedObj['vat'] === null || typeof typedObj['vat'] === 'string') &&
    (typedObj['ssn'] === null || typeof typedObj['ssn'] === 'string') &&
    (typedObj['email'] === null || typeof typedObj['email'] === 'string') &&
    (typedObj['phone'] === null || typeof typedObj['phone'] === 'string') &&
    (typedObj['mobile'] === null || typeof typedObj['mobile'] === 'string') &&
    (typedObj['address'] === null || typeof typedObj['address'] === 'string') &&
    (typedObj['city'] === null || typeof typedObj['city'] === 'string') &&
    (typedObj['locality'] === null || typeof typedObj['locality'] === 'string') &&
    (typedObj['postal_code'] === null || typeof typedObj['postal_code'] === 'string') &&
    (typedObj['country'] === null || typeof typedObj['country'] === 'string')
  );
}

export function isServerError(obj: unknown): obj is ServerError {
  const typedObj = obj as ServerError;
  return (
    ((typedObj !== null && typeof typedObj === 'object') || typeof typedObj === 'function') &&
    typeof typedObj['code'] === 'string' &&
    (typeof typedObj['message'] === 'undefined' || typeof typedObj['message'] === 'string')
  );
}
